import React, { Component } from "react";
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { Container, Row, Col, Card, CardBody,Nav,NavItem,NavLink, Offcanvas, OffcanvasHeader, OffcanvasBody, FormGroup, InputGroup, Label } from "reactstrap";
import {NavLink as RouterNavLink, withRouter  } from "react-router-dom"
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";
import "@fullcalendar/bootstrap/main.css";
import { withTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios";
import { map } from "lodash"
import { API_URL } from "helpers/app_url"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import {  getAppointmentType, getAppointmentPriority, getAppLocationType, getAppDetailById, updateCalendarApp, deleteCalendarApp } from "../../store/actions"
import UpdateButton from "components/buttons/updateBtn";
import DeleteModal from "../../components/Common/DeleteModal";
import moment from "moment";
import SafeField from "helpers/SafeField";
import { For } from "solid-js";
import TimePicker from "components/dropdowns/Timepicker";
import Moment from "react-moment";
class Calendar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      resultArray: [],
      isLoading: false,
      isOffcanvasOpen: false,
      selectedEvent: null,
      activity: '',
       
    }
    this.handleEventClick = this.handleEventClick.bind(this)
    this.onClickDelete = this.onClickDelete.bind(this);
}
toggleDeleteModal = () => {
  this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
  }));
};
onClickDelete = (appointment) => {
  this.setState({ appointment: appointment });
  this.setState({ deleteModal: true });
};
handleDeleteAppointment = () => {
  const { onDeleteAppointment } = this.props;
  const { appointment } = this.state;

  if (appointment.id !== undefined) {
      onDeleteAppointment(appointment);
      this.setState({ deleteModal: false });
  }
};
componentDidMount() {
  const { onGetAppointmentType, onGetAppointmentPriority, onGetAppLocationType} = this.props;

  onGetAppointmentType(localStorage.getItem("userId"));
  onGetAppointmentPriority(localStorage.getItem("userId"));
  onGetAppLocationType(localStorage.getItem("userId"));
  this.postActivity();
}
toggleRight() {
  this.setState(prevState => ({
    isRight: !prevState.isRight,
  }));
}
handleEventClick() {
  this.setState({ event: "", isEdit: false, isRight: !this.state.isRight });
  this.toggleRight();
}
componentDidUpdate(prevProps) {
  if (this.props.userdetail !== prevProps.userdetail && this.props.userdetail) {
    //this.googleEvents();
  }
}
handleEventClick(arg) {
  const event = arg.event;

  // Extract only once for cleaner code
  const { extendedProps } = event;

  const activity = {
    id: extendedProps.id,
    activityType: extendedProps.activityType,
    agentId: extendedProps.agentId,
    contactEmail: extendedProps.contactEmail,
    contactName: extendedProps.contactName,
    contactPhone: extendedProps.contactPhone,
    activityStartDate: extendedProps.activityStartDate,
    startTime: extendedProps.startTime,
    endTime: extendedProps.endTime,
    activityStatus: extendedProps.activityStatus,
    activityRefId: extendedProps.activityRefId,
    activityDescription: extendedProps.activityDescription,
    activityDetails: extendedProps.activityDetails,
    activityLocationType: extendedProps.activityLocationType,
    activityLocation: extendedProps.activityLocation,
    activityLatitude: extendedProps.activityLatitude,
    activityLongitude: extendedProps.activityLongitude,
    isActive: extendedProps.isActive,
  };

  this.setState({
    isOffcanvasOpen: true,
    activity,
  });

  console.log("Event clicked:", activity);
}

postActivity = async () => {
  try {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const payload = {
      activityTypeId: [0],
      activityFromDate:  moment().startOf("month").format("YYYY-MM-DD"),
      activityToDate: moment().add(6, "months").endOf("month").format("YYYY-MM-DD"),
      //refId: parseInt(this.props.match.params.id),
      //refTypeId:2,
      agentId: parseInt(localStorage.getItem('userId'))
    };

    const response = await axios.post(
      `${API_URL}Activity/allfilteredactivities`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );

    //
    const rawEvents = response.data || [];
    const events = rawEvents.map(event => {

    const start = moment(
      `${event.activityStartDate.split("T")[0]} ${event.startTime}`,
      "YYYY-MM-DD hh:mm A"
    ).format("YYYY-MM-DDTHH:mm:ss");

      const end = moment(
        `${event.activityStartDate.split("T")[0]} ${event.endTime}`,
        "YYYY-MM-DD hh:mm A"
      ).format("YYYY-MM-DDTHH:mm:ss");
  const eventStartDate = new Date(start); 
   const now = new Date(); 
        return {
          id: event.activityActivityId,
          title: event.displayTitle,
          activityId: event.activityId,
          start,
          end,
          className: eventStartDate < now ? 'text-dark' : 'text-dark',
          extendedProps: {
             id: event.id,
            activityType: event.activityType,
            agentId: event.agentId,
            contactEmail: event.contactEmail,
            contactName: event.contactName,
            contactPhone: event.contactPhone,
            contactEmail: event.contactEmail,
            activityStartDate: event.activityStartDate,
            startTime: event.startTime,
            endTime: event.endTime,
            activityType: event.activityType,
            activityStatus: event.activityStatus,
            activityRefId: event.activityRefId,
            activityDescription: event.activityDescription,
            activityDetails: event.activityDetails,
            activityLocationType: event.activityLocationType,
            activityLocation: event.activityLocation,
            activityLatitude: event.activityLatitude,
            activityLongitude: event.activityLongitude,
            isActive: event.isActive
          }
        };
      });
  
        this.setState({ resultArray: events,  isLoading: false, });
  } catch (error) {
    console.error("Error posting activity:", error);
  }
};

googleEvents(){
        const userDetail = this.props.userdetail || {}; 
        const agentId = userDetail.agentId;

        if (!agentId) {
          console.error("agentId is undefined. Cannot fetch Google events.");
          return;
        }
          const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
          const userId = localStorage.getItem('userId');
        axios.get(`${API_URL}Google/GetGoogleEventsFromLocal/${agentId}`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(secondResponse => {
            
                const events = secondResponse.data
                .filter(event => event.summary !== null)
                .map(event => {
                  const eventStartDate = new Date(event.startTime); 
                  const now = new Date(); 

                  return {
                    id: event.id,
                    title: event.summary,
                    start: event.startTime,
                    end: event.endTime,
                    location: event.location,
                    eventPageType:event.eventPageType,
                    eventPageId:event.eventPageId,

                    className: eventStartDate < now ? 'bg-danger text-white' : 'bg-success text-white'
                  };
                });
                this.setState({
                  resultArray: events,
                  isLoading: false,
                });
            })
            .catch(error => {
                console.error('Error fetching data from second API:', error);
                this.setState({ isLoading: false });
            });

}
  render() {
    const {  types, priorities, locationTypes, appointment, onUpdateCalendarApp, userdetail } = this.props;
    const { resultArray, isLoading, selectedEvent, deleteModal, activity} = this.state;
    //
    return (
      <div className="page-content">
         <ToastContainer autoClose={2000} />
          {isLoading ? (
                    <div className="rs-loader-overlay">
                    <div className="rs-loader"></div>
                    </div>
                ) : null}
           <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteAppointment}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
        <Container fluid={true}>
          <Breadcrumbs title="Calendar" breadcrumbItem="Calendar" />
          <Row className="mt-20 mb-20">
                <Col sm="3">
                <Nav className="product-view-nav" pills>
                        <NavItem>
                          <NavLink tag={RouterNavLink} to="/activity">
                          
                    
                            <i className="bx bx-grid-alt" />
                          </NavLink>
                        </NavItem>
                        <NavItem>
                        <NavLink tag={RouterNavLink} to="/calendar" activeClassName="active">
                            <i className=" bx bx-calendar" />
                          </NavLink>
                        </NavItem>
                      </Nav>
                </Col>
              </Row>
          <Row>
            <Col className="col-12">
            <Card>
              <CardBody>
              <FullCalendar
                plugins={[
                  dayGridPlugin,
                  interactionPlugin,
                  BootstrapTheme,
                ]}
                initialView="dayGridMonth"
                headerToolbar={{
                  left: "prev,next today",
                  center: "title",
                  right: "dayGridMonth,dayGridWeek,dayGridDay",
                }}
                events={resultArray}
                editable={true}
                droppable={true}
                selectable={true}
                eventClick={this.handleEventClick}
              />
              </CardBody>
            </Card>
             
            </Col>
          </Row>
                      <Offcanvas isOpen={this.state.isOffcanvasOpen} toggle={() => this.setState({ isOffcanvasOpen: false })} direction="end">
                      <OffcanvasHeader toggle={() => this.setState({ isOffcanvasOpen: false })}>
                        Event 
                      </OffcanvasHeader>
                      <OffcanvasBody>
                      <Formik
                                  enableReinitialize={true}
                                  initialValues={{
                                    id: activity.id,
                                    activityType: activity.activityType,
                                    agentId: activity.agentId,
                                    contactEmail: activity.contactEmail,
                                    contactName: activity.contactName,
                                    contactPhone: activity.contactPhone,
                                    activityStartDate: activity.activityStartDate,
                                    startTime: activity.startTime,
                                    endTime: activity.endTime,
                                    activityStatus: activity.activityStatus,
                                    activityRefId: activity.activityRefId,
                                    activityDescription: activity.activityDetails,
                                    activityLocationType: activity.activityLocationType,
                                    activityLocation: activity.activityLocation,
                                    activityLatitude: activity.activityLatitude,
                                    activityLongitude: activity.activityLongitude,
                                    isActive: activity.isActive,
                                }}

                                
                                  validationSchema={Yup.object().shape({
                                    
                                    
                                  })}

                                  onSubmit={values => {

                                   
                                      const updateData = {
                                      id: values.id,
                                      appointmentId: values.appointmentId,
                                      appointmentTitle: values.appointmentTitle,
                                      contactName: values.contactName,
                                      contactPhone: values.contactPhone,
                                      contactEmail: values.contactEmail,
                                      appointmentStartDate: values.appointmentStartDate,
                                      startTime: values.startTime,
                                      endTime: values.endTime,
                                      appointmentType: parseInt(values.appointmentType),
                                      appointmentStatus: parseInt(values.appointmentStatus),
                                      appointmentPriority: parseInt(values.appointmentPriority),
                                      appointmentReminder: values.appointmentReminder,
                                      leadId: values.leadId,
                                      appointmentDescription: values.appointmentDescription,
                                      appointmentLocationType: parseInt(values.appointmentLocationType),
                                      appointmentLocation: values.appointmentLocation,
                                      locationLatitude: values.locationLatitude,
                                      locationLongitude: values.locationLongitude,
                                      isRepeat: values.isRepeat,
                                      repeatEveryType: values.repeatEveryType,
                                      repeatStep: values.repeatStep,
                                      repeatEndDate: values.repeatEndDate,
                                      agentId: values.agentId,
                                      appointmentCategory:values.appointmentCategory,
                                      isActive: values.isActive,
                                      addedBy: values.addedBy,
                                      contactNotes: values.contactNotes,
                                      agentNotes: values.agentNotes,
                                      rejected: values.rejected,
                                      };
                                      onUpdateCalendarApp(updateData);
                                      this.toggleRight();
                                  }}
                                >
                                  {({ errors, touched, values, handleChange, handelBlur, setFieldValue, setFieldTouched }) => (
                                    <Form
                                      className="needs-validation"
                                    >
                                      <Row>
                                        {[2, 3, 4, 12].includes(values.activityType) ? (
                                          <>
                                        <Col md="12">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="activityDescription">Description *</Label>
                                            <SafeField
                                              name="activityDescription"
                                              as="textarea"
                                              className={
                                                "form-control" +
                                                (errors.activityDescription && touched.activityDescription ? " is-invalid" : "")
                                              }
                                            />
                                            <ErrorMessage
                                              name="activityDescription"
                                              component="div"
                                              className="invalid-feedback"
                                            />
                                          </FormGroup>
                                        </Col>
                                         <Col md="12">
                                          <FormGroup className="mb15">

                                            <Label htmlFor="activityStartDate">
                                              {this.props.t("Date")}
                                            </Label>
                                            <Flatpickr
                                              className={
                                                "form-control" +
                                                (errors.activityStartDate && touched.activityStartDate
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              placeholder=""
                                              value={values.activityStartDate}
                                              onChange={(value) => setFieldValue('activityStartDate', value[0])}
                                              options={{
                                                altInput: true,
                                                altFormat: "Y-m-d",
                                                dateFormat: "Y-m-d",
                                                //minDate:'today'
                                              }}
                                            />
                                            <ErrorMessage
                                              name="activityStartDate"
                                              component="div"
                                              className="invalid-feedback"
                                            />
                                          </FormGroup>
                                        </Col>
                                        </>
                                       ) : [1, 8, 10].includes(values.activityType) ? (
                                          <Col md="12">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="activityDescription">
                                              {this.props.t("Agenda*")}
                                            </Label>
                                            <SafeField
                                              name="activityDescription"
                                              type="text"
                                              onChange={handleChange}
                                              className={
                                                "form-control" +
                                                (errors.activityDescription && touched.activityDescription
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              id="activityDescription"
                                            />
                                            <ErrorMessage
                                              name="activityDescription"
                                              component="div"
                                              className="invalid-feedback"
                                            />
                                          </FormGroup>
                                        </Col>
                                        
                                        ): [9].includes(values.activityType) ? (
                                          <>
                                          <Col md="12">
                                            <h5>{values.activityDescription}</h5>
                                          </Col>
                                          <Col md="12">
                                            <h5>Date : {values.activityStartDate ? <Moment format="D MMM YY">{values.activityStartDate}</Moment> : '' }</h5>
                                          </Col>
                                           <Col md="12">
                                            <h5>Start Time : {values.startTime }</h5>
                                          </Col>
                                           <Col md="12">
                                            <h5>End Time : {values.endTime }</h5>
                                          </Col>
                                          </>
                                        ):(
                                          <Col md="12"></Col>
                                        )}
                                       
                                       
                                          {[1, 8, 10].includes(values.activityType) && (
                                            <>
                                             <Col md="12">
                                          <FormGroup className="mb15">

                                            <Label htmlFor="activityStartDate">
                                              {this.props.t("Date")}
                                            </Label>
                                            <Flatpickr
                                              className={
                                                "form-control" +
                                                (errors.activityStartDate && touched.activityStartDate
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              placeholder=""
                                              value={values.activityStartDate}
                                              onChange={(value) => setFieldValue('activityStartDate', value[0])}
                                              options={{
                                                altInput: true,
                                                altFormat: "Y-m-d",
                                                dateFormat: "Y-m-d",
                                                //minDate:'today'
                                              }}
                                            />
                                            <ErrorMessage
                                              name="activityStartDate"
                                              component="div"
                                              className="invalid-feedback"
                                            />
                                          </FormGroup>
                                        </Col>
                                        <Col md="6">
                                             <TimePicker
                                            name="startTime"
                                            label="Start Time *"
                                            value={values.startTime}
                                            onChange={(val) => setFieldValue("startTime", val)}
                                            onBlur={() => setFieldTouched("startTime", true)}
                                            minTime={null}
                                            error={errors.startTime}
                                            touched={touched.startTime}
                                          />
                    
                                          {errors.startTime && touched.startTime && (
                                            <div className="invalid-feedback">{errors.startTime}</div>
                                          )}
                                            
                                        </Col>
                                         
                                        <Col md="6">
                                          <TimePicker
                                          name="endTime"
                                          label="End Time *"
                                          value={values.endTime}
                                          onChange={(val) => setFieldValue("endTime", val)}
                                          onBlur={() => setFieldTouched("endTime", true)}
                                          minTime={values.startTime}
                                          disabled={!values.startTime}
                                          error={errors.endTime}
                                          touched={touched.endTime}
                                        />
                                        </Col>
                                        </>
                                         )}
                                       
                                      </Row>


                                  
                                         
                                      {/* <div className="clearfix">
                                          <UpdateButton>Update</UpdateButton>{" "}
                                          <button type="button" className="btn btn-del-danger w-md" onClick={() => this.onClickDelete(appointment)}> {this.props.t("Delete")}</button>
                                      </div> */}
                                    </Form>
                                  )}
                                </Formik> 
                      </OffcanvasBody>
                    </Offcanvas>
        </Container>
      </div>
    );
  }
}
Calendar.propTypes = {
  t: PropTypes.any,
  onGetAppointmentType:PropTypes.func,
  types:PropTypes.array,
  onGetAppointmentPriority:PropTypes.func,
  priorities:PropTypes.array,
  locationTypes:PropTypes.array,
  onGetAppLocationType:PropTypes.func,
  OnGetAppDetailById:PropTypes.func,
  appointment:PropTypes.object,
  onUpdateCalendarApp:PropTypes.func,
  onDeleteAppointment:PropTypes.func,
  userdetail:PropTypes.object
}
const mapStateToProps = ({ AppoinmentObject }) => (
  {
    appointment: AppoinmentObject.appointment,
    types:AppoinmentObject.types,
    priorities:AppoinmentObject.priorities,
    locationTypes:AppoinmentObject.locationTypes
    
  })
  const mapDispatchToProps = dispatch => ({
    onGetAppointmentType:(agentId) => dispatch(getAppointmentType(agentId)),
    onGetAppointmentPriority:(agentId) => dispatch(getAppointmentPriority(agentId)),
    onGetAppLocationType:(agentId) => dispatch(getAppLocationType(agentId)),
    onUpdateCalendarApp:(data) => dispatch(updateCalendarApp(data)),
    OnGetAppDetailById:(leadId, pageType) => dispatch(getAppDetailById(leadId, pageType)),
    onDeleteAppointment:(id) =>  dispatch(deleteCalendarApp(id)),
  });
  export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Calendar)));

